var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.6C0 5.07452 0 2.81178 1.44101 1.40589C2.88202 0 5.20129 0 9.83984 0H12.2998C16.9383 0 19.2576 0 20.6986 1.40589C22.1396 2.81178 22.1396 5.07452 22.1396 9.6V12V14.4C22.1396 18.9255 22.1396 21.1882 20.6986 22.5941C19.2576 24 16.9383 24 12.2998 24H9.83984C5.20129 24 2.88202 24 1.44101 22.5941C0 21.1882 0 18.9255 0 14.4V9.6Z",
    fill: "url(#paint0_linear_3382_6605)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1873 6.19824C19.1873 6.58186 18.8764 6.8928 18.4928 6.8928L16.5821 6.8928L16.5821 8.80348C16.582 9.1871 16.2712 9.49805 15.8875 9.49805C15.5039 9.49805 15.1931 9.1871 15.193 8.80348L15.193 6.8928L13.2823 6.8928C12.8987 6.8928 12.5878 6.58186 12.5877 6.19824C12.5877 5.81455 12.8986 5.50368 13.2823 5.50368L15.193 5.50368L15.193 3.593C15.193 3.20931 15.5038 2.89844 15.8875 2.89844C16.2712 2.89844 16.5821 3.20931 16.5821 3.593L16.5821 5.50368L18.4928 5.50368C18.8765 5.50368 19.1873 5.81455 19.1873 6.19824Z",
    fill: "#D9C9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55757 15.875C9.13842 15.8752 10.5913 16.7447 11.3388 18.1377L11.8896 19.1641C12.0982 19.5532 11.9524 20.0381 11.5634 20.2471C11.1742 20.4559 10.6884 20.3091 10.4794 19.9199L9.92866 18.8936C9.45981 18.0202 8.54884 17.4748 7.55757 17.4746C6.56617 17.4747 5.65441 18.0201 5.1855 18.8936L4.63471 19.9199C4.42584 20.309 3.94088 20.4556 3.55171 20.2471C3.16264 20.0382 3.01598 19.5532 3.22456 19.1641L3.77632 18.1367C4.52399 16.744 5.97686 15.875 7.55757 15.875Z",
    fill: "#D9C9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55757 8.85547C9.22075 8.85582 10.5701 10.204 10.5703 11.8672C10.5703 13.5305 9.22083 14.8795 7.55757 14.8799C5.89411 14.8798 4.54585 13.5307 4.54585 11.8672C4.54598 10.2038 5.89419 8.8556 7.55757 8.85547ZM7.55757 10.4551C6.77785 10.4552 6.14559 11.0875 6.14546 11.8672C6.14546 12.647 6.77776 13.2792 7.55757 13.2793C8.33718 13.2789 8.96967 12.6469 8.96967 11.8672C8.96954 11.0876 8.33709 10.4554 7.55757 10.4551Z",
    fill: "#D9C9FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3382_6605",
    x1: 3.53639,
    y1: 0.845291,
    x2: 18.0384,
    y2: 24.3235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDAAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A5BFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user-plus.a18add15399e9586347dd26315ee7826.svg";
export { ForwardRef as ReactComponent };